import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Popover } from '@headlessui/react';
import { Icon } from 'new-theme/components/Icons';
import LTButton from 'new-theme/components/LTComponents/LTButton/LTButton';
import LTText from 'new-theme/components/LTComponents/LTText/LTText';
import CopyText from 'new-theme/components/Onboarding/TestRunOptions/Common/CopyText/CopyText';

import ReactTooltip from 'react-tooltip';
import { getCurrentViewPage } from 'new-theme/utils/common';
import { sendAmplitudeEvents } from 'new-theme/utils/amplitude';
import { EventNames } from 'new-theme/utils/events';

import './style.css';

const AccessKey = () => {
  const userData = useSelector((state) => state?.userInfo?.userInfo?.data);

  useEffect(() => {
    const button = document.getElementsByClassName(
      'access-key-action-button'
    )[0];
    button?.addEventListener('click', handleAccessKeyAmplitude);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleCopyLink(linkType) {
    return () => {
      sendAmplitudeEvents(EventNames.HYP_COPY_ACCESS_KEY, {
        copied: linkType,
        view: getCurrentViewPage(),
      });
    };
  }

  function handleAccessKeyAmplitude() {
    sendAmplitudeEvents(EventNames.HYP_CLICK_ON_ACCESS_KEY, {
      view: getCurrentViewPage(),
    });
  }

  return (
    <Popover className="ltw-relative">
      <Popover.Button as="div" role="menu" aria-controls="">
        <LTButton
          leadingIcon={<Icon name="accesskey" aria-hidden="true" />}
          onClick={handleAccessKeyAmplitude}
          role="menuitem"
          id="lt-access-key-btn"
          variant={LTButton.Variant.DEFAULT}
        >
          Access Key
        </LTButton>
      </Popover.Button>
      <Popover.Panel className="ltw-absolute ltw-z-10 ltw-right-0 ltw-mt-1 ltw-bg-white ltw-border ltw-border-gray-14 ltw-rounded">
        <ReactTooltip className="lt-react-tooltip" id="info" />
        <div className="ltw-w-380px">
          <div className="ltw-flex ltw-gap-12px ltw-items-center ltw-p-10px ltw-py-15px">
            <LTText size={12}>Your Access Key Information</LTText>
            <LTButton
              className="lt-access-key-info-button"
              variant={LTButton.Variant.INVISIBLE}
              onKeyDown={() => {}}
              toolTipText="These are the credentials required to run tests with
                    Lambdatest."
            >
              <Icon name={'info-gray'} width={15} height={15} />
            </LTButton>
          </div>
          <div className="ltw-flex ltw-gap-12px ltw-items-center ltw-p-10px ltw-border-t ltw-border-gray-14 ltw-justify-between">
            <LTText size={12}>Username</LTText>
            <div className="ltw-rounded ltw-flex-1 ltw-relative ltw-py-8px ltw-px-10px ltw-flex ltw-justify-between ltw-bg-gray-13 ltw-items-center ltw-max-w-220px">
              <LTText size={12}>{userData?.username}</LTText>
              <CopyText
                onClick={handleCopyLink('username')}
                text={userData?.username}
                onKeyDown={(e) => {
                  if (e.key === 'Tab' && e.shiftKey) {
                    e.preventDefault();
                    e.stopPropagation();
                    document.getElementById('lt-access-key-btn')?.focus();
                  }
                }}
              />
            </div>
          </div>
          <div className="ltw-flex ltw-gap-12px ltw-items-center ltw-p-10px ltw-border-t ltw-border-gray-14 ltw-justify-between">
            <LTText size={12}>Access Key</LTText>
            <div className="ltw-rounded ltw-flex-1 ltw-relative ltw-py-8px ltw-px-10px ltw-flex ltw-justify-between ltw-bg-gray-13 ltw-items-center ltw-max-w-220px">
              <LTText size={12}>
                &lowast;&lowast;&lowast;&lowast;&lowast;&lowast;&lowast;&lowast;&lowast;&lowast;&lowast;
              </LTText>
              <CopyText
                onClick={handleCopyLink('accesskey')}
                text={userData?.apiToken}
                onKeyDown={(e) => {
                  if (e.key === 'Tab' && !e.shiftKey) {
                    const elem = document.getElementById('quickrun-nav-item');
                    if (elem) {
                      e.preventDefault();
                      e.stopPropagation();
                      elem?.focus();
                    } else {
                      const yE = document.getElementById('yaml-link');

                      if (yE) {
                        e.preventDefault();
                        e.stopPropagation();
                        yE?.focus();
                      } else {
                        const btn = document.getElementsByClassName(
                          'lt-segmented-control-button'
                        )[0];
                        if (btn) {
                          btn?.focus();
                        } else {
                          const el = document.getElementById('view-on-git-btn');
                          if (el) {
                            el?.focus();
                          } else {
                            const yamlEle = document.querySelector(
                              '.selected.onboarding-home-page-framework-selector-nav-item'
                            );
                            e.preventDefault();
                            e.stopPropagation();
                            yamlEle?.focus();
                          }
                        }
                      }
                    }
                  }
                }}
              />
            </div>
          </div>
        </div>
      </Popover.Panel>
    </Popover>
  );
};

export default AccessKey;
